import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';

import { cn } from 'lib/utils';

import type {
  ScrollAreaComponent,
  ScrollAreaProps,
  ScrollAreaRef,
  ScrollBarProps,
  ScrollBarRef,
  ScrollBarThumbProps,
  ScrollBarThumbRef,
} from './types';

const ScrollArea = React.forwardRef<ScrollAreaRef, ScrollAreaProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <ScrollAreaPrimitive.Root
        ref={ref}
        className={cn('relative overflow-hidden', className)}
        {...props}
      >
        <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit]">
          {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollAreaPrimitive.Corner />
      </ScrollAreaPrimitive.Root>
    );
  }
) as ScrollAreaComponent;
ScrollArea.displayName = 'ScrollArea';

const ScrollBar = React.forwardRef<ScrollBarRef, ScrollBarProps>(
  ({ className, orientation = 'vertical', children, ...props }, ref) => {
    return (
      <ScrollAreaPrimitive.ScrollAreaScrollbar
        ref={ref}
        orientation={orientation}
        className={cn(
          'flex touch-none select-none transition-colors',
          orientation === 'vertical' &&
            'h-full w-2.5 border-l border-l-transparent p-[1px]',
          orientation === 'horizontal' &&
            'h-2.5 flex-col border-t border-t-transparent p-[1px]',
          className
        )}
        {...props}
      >
        {children ?? <ScrollBarThumb />}
      </ScrollAreaPrimitive.ScrollAreaScrollbar>
    );
  }
);
ScrollBar.displayName = 'ScrollArea.ScrollBar';
ScrollArea.ScrollBar = ScrollBar;

const ScrollBarThumb = React.forwardRef<ScrollBarThumbRef, ScrollBarThumbProps>(
  ({ className, ...props }, ref) => {
    return (
      <ScrollAreaPrimitive.ScrollAreaThumb
        ref={ref}
        className={cn(
          'relative flex-1 rounded-full bg-border',
          className
        )}
        {...props}
      />
    );
  }
);
ScrollBarThumb.displayName = 'ScrollArea.ScrollBarThumb';
ScrollArea.ScrollBarThumb = ScrollBarThumb;

export { ScrollArea };
